export var SHOW_GRID = 'SHOW_GRID';
export var HIDE_GRID = 'HIDE_GRID';
export var IMAGE_THUMB_LOADED = 'IMAGE_THUMB_LOADED';
export var IMAGE_THUMB_FAILED = 'IMAGE_THUMB_FAILED';
